import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const bodyTextVariants = cva("leading-relaxed", {
  variants: {
    size: {
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg md:text-xl",
    },
    color: {
      default: "text-gray-700",
      muted: "text-gray-500",
      white: "text-white",
    },
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right",
    },
  },
  defaultVariants: {
    size: "md",
    color: "default",
    align: "left",
  },
});

interface BodyTextProps extends VariantProps<typeof bodyTextVariants> {
  children: React.ReactNode;
  className?: string;
}

export const BodyText: React.FC<BodyTextProps> = ({
  children,
  size,
  color,
  align,
  className,
}) => {
  return (
    <p className={cn(bodyTextVariants({ size, color, align }), className)}>
      {children}
    </p>
  );
};
